import React from 'react'
import { Link } from 'react-router-dom'
import { useCart } from 'lib/core/hooks/useCart'
import { Button } from 'lib/ui/components/Button'
import { ReactComponent as CartIcon } from 'resources/svg/cart.svg'
import { FadeIn, Spinner } from 'lib/ui/components'
import { useStoreView } from 'hooks/useStoreView'
import { ListWrapper } from './components/ListWrapper'
import { Products } from '../CartOverview/components/Products'

import {
  DropDown,
  Wrapper,
  CartCount,
  Actions
} from './components/Styled'

export const MiniCart = () => {
  const { cart, count } = useCart()

  const isLoading = !cart?.data || cart?.isFirstLoad
  const { isLivBrite } = useStoreView()

  function goToCheckout () {
    window.location.href = '/checkout'
  }

  return (
    <Wrapper
      isLivBrite={isLivBrite}
    >
      {isLoading ? (
        <Link className='cart-link' to='/cart'>
          <Spinner size={16} />
        </Link>
      ) : (
        <FadeIn>
          <Link className='cart-link' to='/cart'>
            <CartIcon />
            {count > 0 && (
              <CartCount>{count}</CartCount>
            )}
          </Link>
          {count > 0 && (
            <DropDown
              className='dropdown'
              isLivBrite={isLivBrite}
            >
              <p className='items-in-cart'><strong>Item(s) in your cart</strong></p>
              {isLivBrite ? (
                <ListWrapper />
              ) : (
                <Products isMiniCart />
              )}
              <Actions
                isLivBrite={isLivBrite}
              >
                <Link to='/cart'>
                  <span>View Cart</span>
                </Link>
                <Button onClick={goToCheckout}>
                  <span>Checkout</span>
                </Button>
              </Actions>
            </DropDown>
          )}
        </FadeIn>
      )}
    </Wrapper>
  )
}
